module.exports = __webpack_public_path__ + "img/imag3.b16d62da.png";